
export const ImagesSize = {
    POST: {
        width: 500,
        height: 350
    }
}